import { HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { SiaComponentInfo } from '../interfaces/sia-component-info';
import { SiaMenu } from '../interfaces/sia-menu';
import { SiaHttpService } from '../services/http.service';

@Injectable({
  providedIn: 'root',
})
export class SiaMenuApi {
  private httpService = inject(SiaHttpService);

  private readonly apiController: string = 'menu';
  private readonly apiControllerCount: string = 'count';

  deleteMenuCache() {
    return this.httpService.deleteOnlyCache('menu');
  }
  // NO REQUEST CACHE
  getUserMenus(deviceType: string) {
    let params = new HttpParams();
    params = params.set('deviceType', `${deviceType}`);
    return this.httpService.get(`${this.apiController}/user-menus`, { params });
  }

  getMenu(menuId: string, deviceType?: string) {
    let params = new HttpParams();
    params = params.set('menuId', `${menuId}`);
    if (deviceType) {
      params = params.set('deviceType', `${deviceType}`);
    }
    return this.httpService.getCache(
      `${this.apiController}/menu`,
      { params },
      `menu-${menuId}`,
    );
  }

  async getComponentInformation(componentId: string): Promise<SiaComponentInfo | null> {
    return await this.httpService.get(
      `${this.apiController}/component-information/${componentId}`,
    );
  }

  // SI REQUEST CACHE
  getMenuLinks(componentId: string | undefined, deviceType: string) {
    return this.httpService.get(
      `${this.apiController}/menu-links/${deviceType}/${componentId}`,
    );
  }

  getMenus() {
    return this.httpService.get(`${this.apiController}/menus`);
  }

  updateSubMenusIndex(subMenus: SiaMenu[]): Promise<boolean> {
    return this.httpService.put(
      `${this.apiController}/sub-menus-index`,
      subMenus,
    );
  }
  updateSidebarMenusIndex(subMenus: SiaMenu[]): Promise<boolean> {
    return this.httpService.put(
      `${this.apiController}/sidebar-menus-index`,
      subMenus,
    );
  }
  getLinkTotalCount(deviceType: string, componentId: string, p: any[]) {
    let pJson = JSON.stringify(p);
    let params = new HttpParams();
    params = params.set('deviceType', `${deviceType}`);
    params = params.set('componentId', `${componentId}`);
    params = params.set('jsonParams', `${pJson}`);
    return this.httpService.get(`${this.apiControllerCount}/total-count`, {
      params,
    });
  }

  saveFavorite(menuId: string, isFavorite: boolean): Promise<boolean> {
    return this.httpService.post(`${this.apiController}/favorite`, {
      menuId,
      isFavorite,
    });
  }
}
